import React, { Fragment, useState } from "react";
import moment from "moment";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link } from "@mui/material";
import UserModal from "@core/components/usermodal";
import EndPoints from "network/Endpoints";
import APICall from "network/APICall";
import QuickSearchToolbar from "views/components/QuickSearchToolbar";
import Loader from "@core/helper/Loader";

const Donationamount = (props) => {
  const {
    donationList,
    pageSize,
    pageNumber,
    setPageSize,
    setPageNumber,
    totalRecord,
    searchText,
    setSearchText,
  } = props;
  const theme = useTheme();

  const [openUserModal, setOpenUserModal] = useState(false);
  const [profileList, setUserProfileList] = useState({});

  const fetchUserProfile = (user_id) => {
    Loader.isLoading(true);
    APICall("post", { user_id }, EndPoints.getUserProfile)
      .then((response) => {
        const { data } = response.data;
        setUserProfileList(data[0]);
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const handleUserModal = (u_id) => {
    setOpenUserModal(!openUserModal);
    if (!openUserModal) {
      fetchUserProfile(u_id);
    }
  };

  const handleClose = () => {
    if (openUserModal) {
      setOpenUserModal(false);
    }
  };

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
  };

  const columns = [
    {
      flex: 0.4,
      minWidth: 70,
      field: "index",
      headerName: "Index",
    },
    {
      flex: 1,
      minWidth: 130,
      field: "name",
      headerName: "name",
      renderCell: ({ row }) => {
        return (
          <Link
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleUserModal(row.user_id);
            }}
          >
            {row?.first_name}
          </Link>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "p_id",
      headerName: "payment id",
    },
    {
      flex: 1,
      minWidth: 130,
      field: "donation_type",
      headerName: "Donation type",
    },

    {
      flex: 1,
      minWidth: 70,
      field: "amount",
      headerName: "Amount",
      renderCell: ({ row }) => {
        const amt = parseFloat(row.amount).toFixed(2);
        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>
            ${amt}
          </Typography>
        );
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "created_at",
      headerName: "Date",
      renderCell: ({ row }) => {
        const fmt = "MMM DD, YYYY hh:mm A";
        const m = moment(row.created_at).format(fmt);
        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>{m}</Typography>
        );
      },
    },
    {
      flex: 1,
      minWidth: 130,
      field: "status",
      headerName: "status",
      renderCell: (params) => {
        const status = params.row.status;

        const check = status === 0 ? false : true;
        return (
          <Box>
            <Button
              type="reset"
              variant="contained"
              size="small"
              style={{
                backgroundColor: check
                  ? theme.palette.primary.light
                  : theme.palette.text.disabled,
                cursor: "text",
              }}
            >
              {status}
            </Button>
          </Box>
        );
      },
    },

    {
      flex: 1,
      minWidth: 150,
      field: "wallet",
      headerName: "Type",
      renderCell: (params) => {
        const p_type = params.row.wallet;
        let check;
        if (p_type === null) {
          check = "Card";
        } else if (p_type === "apple_pay") {
          check = "Apple Pay";
        } else {
          check = "Google Pay";
        }

        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>
            {check}
          </Typography>
        );
      },
    },
  ];

  const assemList = donationList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      ...data
    };
  });

  return (
    <Fragment>
      <Card sx={{ width: "100%", overflowInline: "hidden" }}>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: "No results found" }}
          rowCount={Number(totalRecord)}
          page={pageNumber}
          columns={columns}
          rows={assemList}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 25, 50, 100]}
          components={{ Toolbar: QuickSearchToolbar }}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={() => {}}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              value: searchText,
              clearSearch: () => handleSearch(""),
              onChange: (event) => handleSearch(event.target.value),
              title: "",
              multiDelete: false,
            },
          }}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
          pagination
          paginationMode="server"
        />
      </Card>
      {openUserModal && (
        <UserModal
          open={openUserModal}
          handleClose={handleClose}
          profileList={profileList}
        />
      )}
    </Fragment>
  );
};

export default Donationamount;
